module.exports = __webpack_public_path__ + "fonts/ConfigCondensed-Thin.ca8c2ddf.otf";